import { Injectable,inject } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, switchMap, filter, take } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { KeycloakAdminService } from '../../keycloak/keycloak.service';
import { SecurePersistStateService } from '../../storage/local-storage.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<string | null> =
    new BehaviorSubject<string | null>(null);

  constructor(
    private authService: AuthService,
    private kcAdminService: KeycloakAdminService,
    private storageService: SecurePersistStateService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // const accessToken = this.kcAdminService.kCAdminClient.accessToken;
    // const accessToken = this.storageService.loadState()?.accessToken?.__zone_symbol__value;
    const accessToken = this.storageService.getData('accessToken')
    // console.log('accessToken :>> ', accessToken);
    // Add the Authorization header with the access token to the request
    let authReq = req;
    if (accessToken) {
      authReq = this.addTokenHeader(req, accessToken);
    }

    // console.log('authReq :>> ', authReq);

    return next.handle(authReq).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          // Handle 401 Unauthorized errors
          return this.handle401Error(authReq, next);
        } else {
          // return throwError(error);
          return throwError(() => error);
        }
      })
    );
  }

  // Method to add the access token to the header
  private addTokenHeader(
    req: HttpRequest<any>,
    token: string
  ): HttpRequest<any> {
    // console.log('token :>> ', token);
    return req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`),
    });
  }

  // Handle 401 errors by refreshing the token
  private handle401Error(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.authService.refreshAccessToken().pipe(
        switchMap((token: any) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(token.accessToken);
          return next.handle(this.addTokenHeader(req, token.accessToken));
        }),
        catchError((error) => {
          this.isRefreshing = false;
          // this.authService.logout();
          // The refresh failed, so the session is over. Send the user to
          // sign-in with a notice and a way back to this page, instead of
          // a silent bounce (see KeycloakAdminService.endSession).
          this.kcAdminService.endSession(
            this.kcAdminService.isSessionExpired ? 'expired' : 'signed-out'
          );
          return throwError(() => error);
        })
      );
    } else {
      return this.refreshTokenSubject.pipe(
        filter((token) => token !== null),
        take(1),
        switchMap((token) => next.handle(this.addTokenHeader(req, token!)))
      );
    }
  }
}
